export interface ICrossMatchRejectionReason {
    id: number,
    name: string,
    description: string,
    displayOrder: number,
    secondaryReasons: ICrossMatchRejectionReason[]
}